import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { MdRefresh } from 'react-icons/md';
import { CoreButton } from './../../../../core';
import useStore from './../../store';
/**
 * Button to toggle map legend display if legend is hidden.
 */

var LegendToggleBtn = function LegendToggleBtn(_ref) {
  var props = _extends({}, _ref); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var showMobileLegend = useStore(function (state) {
    return state.showMobileLegend;
  }); // Current breakpoint.

  var breakpoint = useStore(function (state) {
    return state.breakpoint;
  });

  var updateLegend = function updateLegend() {
    // console.log('updateLegend()')
    setStoreValues({
      showMobileLegend: true
    });
  };

  if (!showMobileLegend && (breakpoint === 'xs' || breakpoint === 'sm')) {
    return /*#__PURE__*/React.createElement(CoreButton, {
      color: "",
      active: true,
      id: "map_legend_toggle",
      className: clsx("map-legend-btn"),
      onClick: function onClick() {
        updateLegend();
      },
      label: i18n.translate("UI_MAP_SEE_LEGEND")
    }, i18n.translate("UI_MAP_SEE_LEGEND"));
  } else {
    return '';
  }
};

export default LegendToggleBtn;